import { render, staticRenderFns } from "./EmbedViaIframePopover.vue?vue&type=template&id=206e8641"
import script from "./EmbedViaIframePopover.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmbedViaIframePopover.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports